// extracted by mini-css-extract-plugin
export default {"container":"settings_container__7jgr+","wrapper":"settings_wrapper__gnPUb","sections":"settings_sections__XH4EJ","saveBtn":"settings_saveBtn__xnReJ"};